import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage, LangToggle } from '../contexts/LanguageContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const user = await login(username, password);
      if (!user) {
        setError(t('loginError'));
        return;
      }
      if (user.role === 'admin' || user.role === 'super_admin') {
        navigate('/dashboard');
      } else if (user.role === 'hotesse') {
        navigate('/hostess');
      } else {
        navigate('/home');
      }
    } catch (err) {
      setError(err.message || t('loginError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(160deg, #00C060 0%, #007A38 35%, #004d25 65%, #111111 100%)',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Toggle langue */}
      <div style={{ position: 'absolute', top: '16px', right: '16px', zIndex: 10 }}>
        <LangToggle />
      </div>

      {/* Cercles décoratifs */}
      <div style={{ position: 'absolute', top: '-40px', right: '-40px', width: '220px', height: '220px', borderRadius: '50%', background: 'rgba(0,210,100,0.18)', filter: 'blur(2px)' }}></div>
      <div style={{ position: 'absolute', bottom: '-60px', left: '-40px', width: '260px', height: '260px', borderRadius: '50%', background: 'rgba(0,180,80,0.14)', filter: 'blur(2px)' }}></div>

      <div style={{
        maxWidth: '420px',
        width: '100%',
        background: '#ffffff',
        borderRadius: '24px',
        padding: '40px 36px',
        boxShadow: '0 30px 80px rgba(0, 0, 0, 0.45)',
        border: '3px solid #00A651',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Barre verte en haut */}
        <div style={{
          position: 'absolute',
          top: 0, left: 0, right: 0,
          height: '8px',
          background: 'linear-gradient(90deg, #00C060 0%, #00A651 50%, #006633 100%)',
          borderRadius: '21px 21px 0 0'
        }}></div>

        <div style={{ textAlign: 'center', marginBottom: '28px', marginTop: '10px' }}>
          <img
            src="/logo.png"
            alt="Reaktor Nature Power"
            style={{ width: '150px', height: 'auto', marginBottom: '14px', filter: 'drop-shadow(0 4px 14px rgba(0,166,81,0.3))' }}
          />
          <h3 style={{
            color: '#111111',
            fontWeight: '800',
            margin: '8px 0 4px',
            fontSize: '22px',
            textTransform: 'uppercase',
            letterSpacing: '2px'
          }}>
            {t('scratchCardTitle')}
          </h3>
          <p style={{ color: '#00A651', fontSize: '14px', fontWeight: '700', margin: 0, letterSpacing: '1px' }}>REAKTOR NATURE POWER</p>
        </div>

        {error && (
          <div className="alert mb-3" role="alert" style={{
            background: '#fff0f0',
            border: '2px solid #e53935',
            color: '#b71c1c',
            borderRadius: '10px',
            fontWeight: '600',
            fontSize: '14px'
          }}>
            <i className="fas fa-exclamation-circle me-2"></i>{error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label" style={{ color: '#222222', fontWeight: '700', fontSize: '13px', letterSpacing: '0.5px', marginBottom: '6px' }}>
              {t('username')}
            </label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              style={{ borderRadius: '10px', padding: '13px 14px', border: '2px solid #cccccc', fontSize: '16px', background: '#f9f9f9', color: '#111111', fontWeight: '500' }}
            />
          </div>
          <div className="mb-4">
            <label className="form-label" style={{ color: '#222222', fontWeight: '700', fontSize: '13px', letterSpacing: '0.5px', marginBottom: '6px' }}>
              {t('password')}
            </label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ borderRadius: '10px', padding: '13px 14px', border: '2px solid #cccccc', fontSize: '16px', background: '#f9f9f9', color: '#111111', fontWeight: '500' }}
            />
          </div>
          <button
            type="submit"
            className="btn w-100"
            disabled={loading}
            style={{
              background: 'linear-gradient(135deg, #00C060 0%, #00A651 50%, #006633 100%)',
              border: 'none',
              borderRadius: '12px',
              padding: '15px',
              fontSize: '17px',
              fontWeight: '800',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              color: '#ffffff',
              boxShadow: '0 6px 20px rgba(0,166,81,0.45)'
            }}
          >
            {loading ? (
              <><span className="spinner-border spinner-border-sm me-2"></span>{t('loggingIn')}</>
            ) : t('login')}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '22px' }}>
          <small style={{ color: '#555555', fontWeight: '600', fontSize: '12px' }}>
            © 2026 REAKTOR NATURE POWER
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;
